import React, { useState, useEffect, useMemo } from 'react';
import { convertConnectionTypesToServiceType } from '../../../constants/utils/connectionTypes';
import * as R from "ramda";


export const DossiersCard = ({ srv, index, setServiceDataLetters, setSelectedServices, setSelectedUserService, setServiceLetter, userState }) => {

	let noneLetter = ["Traité", "Non rempli", "Lettres générées"];
	let greenStatus = ["Lettres validées", "Lettres imprimées", "Lettres postées", "Lettres distribuées", "Traité", "En livraison"];
    let blueStatus = ["Lettres non selectionnées", "Lettres générées", "Rempli"];
    function getSomeLettersEqualTo(userLetters, property) { return userLetters.some(letter => letter.letterProgressStage === property); };
	function allLetterHaveStatus(userLetters, status) {
        if(R.isEmpty(userLetters)){
            return false;
        }
        return userLetters.every(letter => letter.letterProgressStage === status); 
    };


    let progress = 100;
    let chosenServiceData = userState.serviceDatas.filter(s => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType));
    let userLettersFiltered = userState.userLetters.filter(ul => chosenServiceData.some(sd => sd.id === ul.userServiceId));
    let validUserLetters = userLettersFiltered.filter(letter => letter.letterProgressStage !== "Abandonned");
    let status;
    if (!R.isEmpty(chosenServiceData)) {

        status = "Rempli";

        const userLettersCreated = R.isEmpty(userLettersFiltered) ? false : userLettersFiltered.every(letter => letter.letterProgressStage === "Created");
        const userLettersValidated = getSomeLettersEqualTo(userLettersFiltered, "Validated");
        const userLettersPrinted = getSomeLettersEqualTo(userLettersFiltered, "Printed");
        const userLettersSentPost = getSomeLettersEqualTo(userLettersFiltered, "SentToPost");
        const userLettersInDelivery = getSomeLettersEqualTo(userLettersFiltered, "InDelivery");
        const userLettersDelivered = getSomeLettersEqualTo(userLettersFiltered, "Delivered");
        const userLettersAbandonned = allLetterHaveStatus(userLettersFiltered, "Abandonned")

        if (userLettersCreated) {

            status = "Lettres générées";

        } else if (userLettersAbandonned){
            status = "Traité";

        }else if (userLettersValidated) {

            status = "Lettres validées";

        } else if (userLettersPrinted) {

            status = "Lettres imprimées";

        } else if (userLettersSentPost) {

            status = "Lettres postées";
        } else if (userLettersInDelivery) {

            status = "En livraison";
        } else if (userLettersDelivered) {

            status = "Lettres distribuées";
        }


    } else {

        status = "Non rempli";

    }

    return (
        <div className="form-group col col-lg-3 col-xl-2" key={index}>
            <div key={index} className="card rounded p-2 text-center picker-card paper-shadow--hover border-none">
                <div className="card-column" data-toggle="modal" data-target={!noneLetter.includes(status) ? "#previewDoc" : ""} onClick={() => {
                    setServiceDataLetters(validUserLetters);
                    setSelectedServices(chosenServiceData);
                    setSelectedUserService(!R.isEmpty(chosenServiceData) ? chosenServiceData[0] : []);
                    setServiceLetter([]);
                }}>
                    <img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
                    <h3 className={"h6 text-uppercase font-weight-bolder word-fluid" + (status !== "Non rempli" ? ' my-auto' : ' container-tight mx-auto mt-auto')}>{srv.title}</h3>
                    <p className={"small font-weight-demi mt-auto lh-copy o-0 mb-2"}>Envoyer jusqu'au jour</p>
                    <div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center" + (status !== "Non rempli" ? ' bg-white' : ' bg-common 0')}>
                        <div className={"progress-bar h-100 rounded-inherit o-20" + (greenStatus.includes(status) ? ' bg-secondary' : ' ') + (status === "Non rempli" ? ' gradient-prime' : ' ') + (blueStatus.includes(status) ? ' bg-info' : " ")} style={{ width: `${progress}%` }} role="progressbar"></div>
                        <div className={"h5 d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (status === "Non rempli" ? ' text-danger' : " ") + (blueStatus.includes(status) ? ' text-info' : " ") + (greenStatus.includes(status) ? ' text-secondary' : " ")} role="progressbar">{status}</div>
                    </div>
                </div>
                {/* <p className={"small font-weight-demi mt-auto lh-copy mb-2 picker-validated"}>Dernière mise à jour: 17/08/2020</p> */}

            </div>
        </div>
    );
}